import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { Autoplay } from 'swiper/modules';
import 'swiper/css/autoplay';
import styled from 'styled-components';
import {
  minBreakpointQuery,
  standardColours,
  brandColours,
  fontWeights,
  fontSize,
} from '../styles';
import { Container, HtmlContent, Slider } from './ui';

const StyledSitewideNotice = styled.div`
  padding: 10px 0;
  text-align: center;
  background-color: ${brandColours.quinary};

  p {
    margin: 0;
    font-weight: ${fontWeights.regular};
    ${fontSize(14)};
    line-height: 1.5;

    ${minBreakpointQuery.large`
      ${fontSize(15)};
    `}
  }

  a {
    color: ${standardColours.darkGrey};
  }
`;

const StyledSlider = styled(Slider)`
  .swiper-slide {
    margin: auto;
  }
`;

const SitewideNotice = () => {
  const {
    datoCmsHeader: { sitewideNotices },
  } = useStaticQuery(graphql`
    query HeaderQuery {
      datoCmsHeader {
        sitewideNotices {
          text
        }
      }
    }
  `);

  const sliderOptions = {
    modules: [Autoplay],
    slidesPerView: 1,
    loop: true,
    autoplay: {
      delay: 5000,
      pauseOnMouseEnter: true,
      disableOnInteraction: false,
    },
    speed: 1000,
  };

  return (
    sitewideNotices.length > 0 && (
      <StyledSitewideNotice>
        <Container>
          <StyledSlider {...sliderOptions}>
            {sitewideNotices.map(({ text }, id) => (
              <HtmlContent key={id} html={text} />
            ))}
          </StyledSlider>
        </Container>
      </StyledSitewideNotice>
    )
  );
};

export default SitewideNotice;
